import "./styles.scss";
import React, { FC, useState, useEffect } from "react";


interface IProps {
  company: {
    company_id: string;
    name: string;
    tags: any
  };
}

const CompanyPortfoliosCard: FC<IProps> = (props) => {
  // const { paperstreet } = useSelector((state: IState) => state);
  const { company } = props;

  const [portfolioTags, setPortfolioTags] = useState<any[]>([]);

  useEffect(() => {
    if (!company) {
      return;
    }

    if (!company.tags) {
      return;
    }

    let portfolioTags = company.tags.filter((tag) => {
      if (tag.tag_type === "portfolio_tag") {
        if (!tag.meta_data) {
          return false;
        }

        if (!tag.meta_data.isDiscoverable) {
          return false;
        }

        if (tag.meta_data.isDiscoverable === true) {
          return true;
        }

        return false;
      }
    });

    setPortfolioTags(portfolioTags);

  }, [company]);

  return (
    <>
      {portfolioTags && portfolioTags.length > 0 && (
        <div
          className="ps-company-detail-content__portfolios-card"
          style={{ height: "fit-content" }}
        >
          <div className="ps-company-portfolios-card__portfolios-text">
            Portfolios
          </div>

          <div className="ps-company-portfolios-card__list-container">
            {portfolioTags.map((portfolioTag, index) => (
              <div
                key={index}
                className="ps-company-portfolios-card__row-container"
              >
                <a
                  href={portfolioTag.meta_data.landingPageUrl}
                  className="ps-company-portfolios-card__anchor-container"
                >
                  <div className="ps-company-portfolios-card__inner-row-container">
                    <div className="ps-company-portfolios-card__icon-name-container">
                      <img
                        src="/images/icons/double-carat.svg"
                        alt="Class Double Caret"
                        className="ps-company-portfolio-card__list-item-icon"
                      />

                      <div className="ps-company-portfolios-card__display-name-text">
                        {portfolioTag.display_name}
                      </div>
                    </div>
                    <div className="ps-profile--class-card-caret-container">
                      <img
                        className=""
                        src="/images/icons/caret-right.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default CompanyPortfoliosCard;
